import { fromJS } from 'immutable'

import {
  PASSWORD_RECOVERY_POST,
  PASSWORD_SET_POST,
  PASSWORD_RESET_POST,
  PASSWORD_RECOVERY_UPDATE,
  PASSWORD_SET_UPDATE,
  PASSWORD_ERROR,
} from 'actions/password'

// Reducer
// ---------------------------------------------------------------------------

export const initialState = fromJS({
  error: false,
  errorData: null,
  loading: false,
  recoveryReturnData: null,
  setReturnData: null,
})

export default function createPasswordReducer(state = initialState, action) {
  switch (action.type) {
    case PASSWORD_RECOVERY_POST:
      return _postPasswordRecovery(state)
    case PASSWORD_SET_POST:
    case PASSWORD_RESET_POST:
      return _postPasswordSet(state)
    case PASSWORD_RECOVERY_UPDATE:
      return _updatePasswordRecovery(state, action.payload)
    case PASSWORD_SET_UPDATE:
      return _updatePasswordSet(state, action.payload)
    case PASSWORD_ERROR:
      return _errorPassword(state, action.payload)
    default:
      return state
  }
}

const _postPasswordRecovery = state => {
  return state.update('loading', () => true)
}

const _postPasswordSet = state => {
  return state.update('loading', () => true)
}

const _updatePasswordRecovery = (state, payload) => {
  return state
    .set('recoveryReturnData', fromJS(payload.data))
    .update('loading', () => false)
    .update('error', () => false)
    .update('errorData', () => null)
}

const _updatePasswordSet = (state, payload) => {
  return state
    .set('setReturnData', fromJS(payload.data))
    .update('loading', () => false)
    .update('error', () => false)
    .update('errorData', () => null)
}

const _errorPassword = (state, payload) => {
  return state
    .set('error', payload.error)
    .set('errorData', fromJS(payload.data))
    .update('loading', () => false)
}
